/* Oshea redesign 2026 — storefront behaviour (no dependencies) */
(function () {
  'use strict';
  var O = window.OSH || {};
  var root = O.root || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var KEYS = ['المنتج الاول', 'المنتج الثاني', 'المنتج الثالث'];

  function fmt(c) { c = Math.round(c); var v = c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2); return v + ' د.أ'; }
  function say(msg) { var l = $('#o-live'); if (!l) return; l.textContent = ''; setTimeout(function () { l.textContent = msg; }, 60); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw new Error(j.description || j.message || 'حدث خطأ، حاول مرة ثانية.'); } return j; }); });
  }

  var openEl = null, lastFocus = null;
  var scrim = function () { return $('[data-o-scrim]'); };
  function focusables(el) { return $$('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', el).filter(function (x) { return x.offsetParent !== null; }); }
  function openDialog(id, trigger) {
    var el = document.getElementById(id); if (!el) return;
    if (openEl) closeDialog(true);
    lastFocus = trigger || document.activeElement; openEl = el;
    el.classList.add('is-open'); var s = scrim(); if (s) s.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var f = focusables(el); (f[0] || el).focus(); }, 30);
  }
  function closeDialog(silent) {
    if (!openEl) return;
    var id = openEl.id; openEl.classList.remove('is-open'); openEl = null;
    var s = scrim(); if (s) s.hidden = true;
    document.documentElement.style.overflow = '';
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (openEl) closeDialog(); var sb = $('#o-search'); if (sb && !sb.hidden) closeSearch(); }
    if (e.key === 'Tab' && openEl) {
      var f = focusables(openEl); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  function closeSearch() { var s = $('#o-search'); if (!s) return; s.hidden = true; var b = $('[data-o-search-open]'); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); } }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    var x;
    if ((x = t.closest('[data-o-open]'))) { e.preventDefault(); openDialog(x.getAttribute('data-o-open'), x); return; }
    if ((x = t.closest('[data-o-cart-open]'))) { e.preventDefault(); openDialog('o-cart', x); return; }
    if (t.closest('[data-o-close]') || t.closest('[data-o-scrim]')) { e.preventDefault(); closeDialog(); return; }
    if ((x = t.closest('[data-o-search-open]'))) { var s = $('#o-search'); s.hidden = false; x.setAttribute('aria-expanded', 'true'); $('#o-q').focus(); return; }
    if (t.closest('[data-o-search-close]')) { closeSearch(); return; }
    if ((x = t.closest('[data-o-qty]'))) { e.preventDefault(); var li = x.closest('[data-key]'); if (li) changeLine(li.getAttribute('data-key'), parseInt(x.getAttribute('data-o-qty'), 10), x); return; }
    if ((x = t.closest('[data-o-video]'))) { playVideo(x); return; }
    if ((x = t.closest('[data-o-apply]'))) { applyConvert(x); return; }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-o-qtyin]')) { var li = t.closest('[data-key]'); var n = parseInt(t.value, 10); if (li && n >= 0) changeLine(li.getAttribute('data-key'), n, t); }
  });

  function setCount(n) {
    $$('[data-o-count]').forEach(function (c) { c.textContent = n; c.hidden = !n; });
    $$('[data-o-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'سلة التسوق، عدد المنتجات ' + n); });
  }
  function refreshCart(open) {
    return fetch(root + '?sections=osh-cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['osh-cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-o-cart]', doc), cur = $('[data-o-cart]');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
        var body = $('[data-o-cart-body]', doc); setCount(body ? parseInt(body.getAttribute('data-count'), 10) || 0 : 0);
        initConvert();
        if (open) openDialog('o-cart', document.activeElement);
      });
  }
  function changeLine(key, qty, el) {
    var box = el && el.closest('[data-o-cart-body]');
    if (box) box.setAttribute('aria-busy', 'true');
    post('/cart/change.js', { id: key, quantity: Math.max(0, qty) })
      .then(function () {
        say(qty === 0 ? 'تمت إزالة المنتج من السلة' : 'تم تحديث الكمية');
        if (box && box.hasAttribute('data-page')) { location.reload(); return; }
        return refreshCart(false).then(function () { var f = focusables($('#o-cart') || document); if (f[0]) f[0].focus(); });
      })
      .catch(function (err) { say(err.message); if (box) box.removeAttribute('aria-busy'); alert(err.message); });
  }

  function initConvert() {
    $$('[data-o-convert]').forEach(function (box) {
      var list = box.parentElement.querySelector('[data-o-lines]'); if (!list) return;
      var units = [];
      $$('[data-offer-name]', list).forEach(function (li) {
        var q = parseInt(li.getAttribute('data-qty'), 10) || 0, u = parseInt(li.getAttribute('data-unit'), 10) || 0;
        for (var i = 0; i < q; i++) units.push({ key: li.getAttribute('data-key'), name: li.getAttribute('data-offer-name'), price: u });
      });
      units.sort(function (a, b) { return b.price - a.price; });
      var p2 = +list.getAttribute('data-p2'), p3 = +list.getAttribute('data-p3');
      var ok2 = list.getAttribute('data-ok2') === 'true', ok3 = list.getAttribute('data-ok3') === 'true';
      var plan = null;
      if (ok3 && units.length >= 3) { var s3 = units[0].price + units[1].price + units[2].price; if (s3 > p3) plan = { n: 3, sum: s3, price: p3, vid: list.getAttribute('data-v3'), units: units.slice(0, 3) }; }
      if (!plan && ok2 && units.length >= 2) { var s2 = units[0].price + units[1].price; if (s2 > p2) plan = { n: 2, sum: s2, price: p2, vid: list.getAttribute('data-v2'), units: units.slice(0, 2) }; }
      if (!plan) { box.hidden = true; return; }
      box._plan = plan;
      var names = plan.units.map(function (u) { return u.name; }).join('، ');
      box.innerHTML = '<p><b>' + (plan.n === 3 ? '3 منتجات' : 'منتجان') + ' بـ' + fmt(plan.price) + '</b> بدل ' + fmt(plan.sum) + ' — ' + names + '</p>' +
        '<button type="button" class="o-btn o-btn--dark o-btn--block" data-o-apply>طبّق العرض ووفّر ' + fmt(plan.sum - plan.price) + '</button>';
      box.hidden = false;
    });
  }
  function applyConvert(btn) {
    var box = btn.closest('[data-o-convert]'); var plan = box && box._plan; if (!plan) return;
    btn.disabled = true;
    var list = box.parentElement.querySelector('[data-o-lines]');
    var updates = {};
    plan.units.forEach(function (u) {
      if (!(u.key in updates)) { var li = list.querySelector('[data-key="' + u.key + '"]'); updates[u.key] = parseInt(li.getAttribute('data-qty'), 10) || 0; }
      updates[u.key] -= 1;
    });
    var props = {}; plan.units.forEach(function (u, i) { props[KEYS[i]] = u.name; });
    post('/cart/update.js', { updates: updates })
      .then(function () { return post('/cart/add.js', { items: [{ id: +plan.vid, quantity: 1, properties: props }] }); })
      .then(function () { say('تم تطبيق العرض'); if (box.closest('[data-page]')) { location.reload(); return; } return refreshCart(false); })
      .catch(function (err) { btn.disabled = false; alert(err.message); });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('[data-o-add]')) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]'); var err = f.querySelector('[data-o-err]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (err) err.hidden = true;
    var fd = new FormData(f);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'تعذّرت الإضافة للسلة.'); return j; }); })
      .then(function () { say('تمت الإضافة للسلة'); return refreshCart(true); })
      .catch(function (x) { if (err) { err.textContent = x.message; err.hidden = false; } else { alert(x.message); } })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  });

  function initPdp() {
    var pdp = $('[data-o-pdp]'); if (!pdp) return;
    var track = $('[data-o-track]', pdp), cur = $('[data-o-cur]', pdp);
    if (track) {
      var slides = $$('.o-gal__slide', track);
      var idx = function () { return Math.round(Math.abs(track.scrollLeft) / track.clientWidth); };
      var go = function (i) { i = Math.max(0, Math.min(slides.length - 1, i)); slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); };
      track.addEventListener('scroll', function () {
        var i = idx(); if (cur) cur.textContent = i + 1;
        $$('[data-o-thumb]', pdp).forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }, { passive: true });
      var nx = $('[data-o-next]', pdp), pv = $('[data-o-prev]', pdp);
      if (nx) nx.addEventListener('click', function () { go(idx() + 1); });
      if (pv) pv.addEventListener('click', function () { go(idx() - 1); });
      $$('[data-o-thumb]', pdp).forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-o-thumb')); }); });
    }
    $$('[data-o-step]', pdp).forEach(function (b) {
      b.addEventListener('click', function () { var i = b.parentElement.querySelector('input'); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.getAttribute('data-o-step'), 10)); });
    });
    var form = $('[data-o-main-form]', pdp), atc = $('[data-o-atc]', pdp), sticky = $('[data-o-sticky]'), sbtn = $('[data-o-sticky-btn]');
    var vsel = $('[data-o-vsel]', pdp), vjson = $('[data-o-variants]', pdp);
    if (vsel && vjson) {
      var vars = JSON.parse(vjson.textContent);
      vsel.addEventListener('change', function () {
        var v = vars.filter(function (x) { return String(x.id) === vsel.value; })[0]; if (!v) return;
        var p = $('[data-o-price]', pdp); if (p) p.innerHTML = '<span class="o-num">' + fmt(v.price).replace(' د.أ', '') + '</span> د.أ' + (v.compare_at_price > v.price ? '<s>' + fmt(v.compare_at_price) + '</s>' : '');
        var sp = $('[data-o-sprice]'); if (sp) sp.textContent = fmt(v.price);
        [atc, sbtn].forEach(function (b) { if (!b) return; b.disabled = !v.available; b.textContent = v.available ? 'أضف للسلة' : 'غير متوفر حاليًا'; });
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      });
    }
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var off = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', off); sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
        if (sbtn) sbtn.tabIndex = off ? 0 : -1;
      }).observe(atc);
      if (sbtn) sbtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else atc.click(); });
    }
  }

  function initBuilder() {
    var b = $('[data-o-builder]'); if (!b) return;
    var target = +b.getAttribute('data-target'), price = +b.getAttribute('data-price'), vid = +b.getAttribute('data-vid');
    var sum = $('[data-o-sum]'), slots = $$('.o-slot', sum), status = $('[data-o-status]', sum), save = $('[data-o-save]', sum), errEl = $('[data-o-berr]', sum), submit = $('[data-o-bsubmit]', sum);
    var cards = $$('.o-card[data-name]', b); var picks = [];
    var params = new URLSearchParams(location.search); var from = params.get('from');
    function cardOf(name) { return cards.filter(function (c) { return c.getAttribute('data-name') === name; })[0]; }
    function render() {
      slots.forEach(function (s, i) {
        var p = picks[i]; s.classList.toggle('is-full', !!p);
        s.querySelector('.o-slot__name').textContent = p ? p.name : 'لم يتم الاختيار';
      });
      cards.forEach(function (c) {
        var on = picks.some(function (p) { return p.name === c.getAttribute('data-name'); });
        c.classList.toggle('is-picked', on);
        var btn = $('[data-o-pick]', c); btn.textContent = on ? 'إزالة' : 'اختر المنتج';
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.disabled = !on && picks.length >= target;
      });
      status.innerHTML = 'تم اختيار <span class="o-num">' + picks.length + '</span> من <span class="o-num">' + target + '</span>';
      var reg = picks.reduce(function (a, p) { return a + p.price; }, 0);
      if (picks.length === target && reg > price) { save.textContent = 'السعر العادي ' + fmt(reg) + ' — توفّر ' + fmt(reg - price); save.hidden = false; }
      else if (picks.length === target && reg <= price) { save.textContent = 'ملاحظة: مجموع السعر العادي لهذه المنتجات ' + fmt(reg) + '، وهو أقل من سعر العرض.'; save.hidden = false; }
      else { save.hidden = true; }
      submit.disabled = picks.length !== target;
      $$('[data-o-mode]', b).forEach(function (a) {
        var u = new URL(a.href, location.origin); if (picks.length) u.searchParams.set('pre', picks.map(function (p) { return p.name; }).join('|')); else u.searchParams.delete('pre');
        if (from) u.searchParams.set('from', from); a.href = u.pathname + u.search;
      });
    }
    function toggle(c) {
      var name = c.getAttribute('data-name'); var i = picks.map(function (p) { return p.name; }).indexOf(name);
      if (i > -1) { picks.splice(i, 1); say('تمت إزالة ' + name); }
      else if (picks.length < target) { picks.push({ name: name, price: +c.getAttribute('data-price') }); say('تم اختيار ' + name + '، ' + picks.length + ' من ' + target); }
      errEl.hidden = true; render();
    }
    cards.forEach(function (c) { $('[data-o-pick]', c).addEventListener('click', function () { toggle(c); }); });
    var pre = params.get('pre');
    if (pre) pre.split(/[|,]/).forEach(function (n) { n = n.trim(); var c = cardOf(n); if (c && picks.length < target && !picks.some(function (p) { return p.name === n; })) picks.push({ name: n, price: +c.getAttribute('data-price') }); });
    $$('[data-o-f]', b).forEach(function (fb) {
      fb.addEventListener('click', function () {
        var k = fb.getAttribute('data-o-f');
        $$('[data-o-f]', b).forEach(function (x) { x.setAttribute('aria-pressed', x === fb ? 'true' : 'false'); });
        cards.forEach(function (c) { c.hidden = !!k && c.getAttribute('data-cat') !== k; });
      });
    });
    submit.addEventListener('click', function () {
      if (picks.length !== target) return;
      submit.disabled = true; submit.setAttribute('aria-busy', 'true'); errEl.hidden = true;
      var props = {}; picks.forEach(function (p, i) { props[KEYS[i]] = p.name; });
      var first = from ? post('/cart/change.js', { id: from, quantity: 0 }).catch(function () { }) : Promise.resolve();
      first.then(function () { return post('/cart/add.js', { items: [{ id: vid, quantity: 1, properties: props }] }); })
        .then(function () {
          from = null; picks = []; render(); say('تمت إضافة العرض للسلة');
          var u = new URL(location.href); u.searchParams.delete('from'); u.searchParams.delete('pre'); history.replaceState(null, '', u);
          return refreshCart(true);
        })
        .catch(function (x) { errEl.textContent = x.message || 'تعذّرت الإضافة للسلة.'; errEl.hidden = false; submit.disabled = false; })
        .then(function () { submit.removeAttribute('aria-busy'); });
    });
    render();
  }

  function playVideo(btn) {
    var sec = btn.closest('section'); var tpl = $('[data-o-video-tpl]', sec); var slot = $('[data-o-video-slot]', sec);
    if (!tpl || !slot) return;
    slot.hidden = false; slot.innerHTML = ''; slot.appendChild(tpl.content.cloneNode(true));
    var v = $('video', slot); if (v) { v.style.width = '100%'; v.style.height = '100%'; v.focus(); }
    btn.hidden = true;
  }
  function initRecs() {
    $$('[data-o-recs]').forEach(function (s) {
      if (s.children.length) return;
      var load = function () { fetch(s.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (h) { var d = new DOMParser().parseFromString(h, 'text/html'); var n = $('[data-o-recs]', d); if (n) s.innerHTML = n.innerHTML; }).catch(function () { }); };
      if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' }); io.observe(s); } else load();
    });
  }

  function init() { initPdp(); initBuilder(); initConvert(); initRecs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
